import { featuredCategories } from '@/mocks/categories';

export default function FeatureGrid() {
  const scroll = (dir: 'left' | 'right') => {
    const container = document.getElementById('feature-scroll');
    if (container) {
      const amount = dir === 'left' ? -300 : 300;
      container.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-14">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Scopri <span className="text-primary-500">itaobuy</span> sheet
            </h2>
            <p className="text-foreground-500 text-sm mt-3 max-w-lg">
              Database organizzato con le migliori selezioni per ogni categoria. Trova rapidamente i prodotti che cerchi.
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs font-medium whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            Live Database
          </span>
        </div>

        {/* Scrollable cards */}
        <div className="relative">
          <div
            id="feature-scroll"
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-2 -mx-4 px-4 scroll-smooth"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {featuredCategories.map((cat, i) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-64 md:w-72 group cursor-pointer"
              >
                <div className="bg-background-100 rounded-xl overflow-hidden">
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={cat.imageUrl}
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-foreground-900 font-semibold text-sm group-hover:text-primary-500 transition-colors">
                      {cat.name}
                    </h3>
                    <p className="text-foreground-400 text-xs mt-1">
                      Categoria {String(i + 1).padStart(2, '0')}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <button
            onClick={() => scroll('left')}
            className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 w-9 h-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-background-300 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button
            onClick={() => scroll('right')}
            className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 w-9 h-9 items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}